// import ReactQuill from "react-quill";
// import DOMPurify from "dompurify";
// import "react-quill/dist/quill.snow.css";

// /* ---------------- CLEANER ---------------- */

// const cleanPastedHtml = (html) => {
//     let cleaned = DOMPurify.sanitize(html, {
//         ALLOWED_TAGS: [
//             "p", "br", "strong", "b", "em", "i", "u",
//             "ul", "ol", "li",
//             "a", "img",
//             "table", "tbody", "tr", "td", "th",
//             "h1", "h2", "h3", "blockquote", "span"
//         ],
//         ALLOWED_ATTR: [
//             "href", "src", "alt", "target",
//             "colspan", "rowspan",
//             "style"
//         ]
//     });

//     cleaned = cleaned

//         // remove Gmail / Outlook junk classes
//         .replace(/class="[^"]*"/gi, "")

//         // remove weird margins / padding / fonts
//         .replace(/margin[^;"]*;?/gi, "")
//         .replace(/padding[^;"]*;?/gi, "")
//         .replace(/font-family[^;"]*;?/gi, "")
//         .replace(/line-height[^;"]*;?/gi, "")
//         .replace(/mso-[^;"]*;?/gi, "") // outlook

//         // convert div to p
//         .replace(/<div/gi, "<p")
//         .replace(/<\/div>/gi, "</p>")

//         // remove empty tags
//         .replace(/<p><br><\/p>/gi, "")
//         .replace(/<p>\s*<\/p>/gi, "")

//         // fix tables width
//         .replace(/<table/gi, `<table style="width:100%; border-collapse:collapse;"`)

//         // fix images
//         .replace(/<img/gi,
//             `<img style="max-width:100%;height:auto;display:block;margin:10px auto;"`)

//         // links
//         .replace(/<a /gi,
//             `<a style="color:#0d6efd;text-decoration:none;" target="_blank" `);

//     return cleaned;
// };

// /* ---------------- COMPONENT ---------------- */

// const EmailEditor = ({ emailContent, setEmailContent }) => {

//     const modules = {
//         toolbar: [
//             [{ header: [1, 2, 3, false] }],
//             ["bold", "italic", "underline"],
//             [{ color: [] }, { background: [] }],
//             [{ align: [] }],
//             [{ list: "ordered" }, { list: "bullet" }],
//             ["link", "image"],
//             ["clean"]
//         ],

//         clipboard: {
//             matchVisual: false
//         }
//     };

//     const formats = [
//         "header",
//         "bold",
//         "italic",
//         "underline",
//         "color",
//         "background",
//         "align",
//         "list",
//         "bullet",
//         "link",
//         "image"
//     ];

//     const handleChange = (content) => {
//         setEmailContent(content);
//     };

//     const handlePaste = (e) => {
//         const html = e.clipboardData.getData("text/html");

//         if (html) {
//             e.preventDefault();

//             const cleanHtml = cleanPastedHtml(html);

//             setEmailContent((prev) => prev + cleanHtml);
//         }
//     };

//     return (
//         <div onPaste={handlePaste}>
//             <ReactQuill
//                 theme="snow"
//                 value={emailContent}
//                 onChange={handleChange}
//                 modules={modules}
//                 formats={formats}
//                 placeholder="Write or paste Gmail content here..."
//                 style={{
//                     background: "white",
//                     minHeight: "320px"
//                 }}
//             />

//             <style>
//                 {`
//                 .ql-editor{
//                     min-height:280px;
//                     font-family:Arial,sans-serif;
//                     font-size:15px;
//                     line-height:1.6;
//                 }

//                 .ql-editor img{
//                     max-width:100%;
//                     height:auto;
//                 }

//                 .ql-editor table{
//                     width:100%;
//                     border-collapse:collapse;
//                 }

//                 .ql-editor td,.ql-editor th{
//                     border:1px solid #ddd;
//                     padding:8px;
//                 }
//                 `}
//             </style>
//         </div>
//     );
// };

// export default EmailEditor;











import ReactQuill from "react-quill";
import DOMPurify from "dompurify";
import "react-quill/dist/quill.snow.css";

/* ---------------- CLEANER ---------------- */

const cleanPastedHtml = (html) => {
    // 1) Sanitize first — strips disallowed tags/attrs (script, div, class-based junk, etc.)
    const sanitized = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            "p", "br", "strong", "b", "em", "i", "u",
            "ul", "ol", "li",
            "a", "img",
            "table", "tbody", "tr", "td", "th",
            "h1", "h2", "h3", "blockquote", "span"
        ],
        ALLOWED_ATTR: [
            "href", "src", "alt", "target",
            "colspan", "rowspan",
            "style"
        ]
    });

    // 2) Parse into a real DOM so attribute edits don't create duplicate
    //    style="" attributes or break tag nesting (regex on raw HTML strings
    //    can't safely do this).
    const container = document.createElement("div");
    container.innerHTML = sanitized;

    // Remove any leftover class attributes (Gmail/Outlook junk classes)
    container.querySelectorAll("[class]").forEach((el) => {
        el.removeAttribute("class");
    });

    // Strip noisy inline style props (margin/padding/font-family/line-height/mso-*)
    // without nuking the rest of the style attribute.
    container.querySelectorAll("[style]").forEach((el) => {
        const rules = el.getAttribute("style").split(";");

        const keptRules = rules.filter((rule) => {
            const prop = rule.split(":")[0]?.trim().toLowerCase() || "";
            if (!prop) return false;

            const isNoisy =
                prop.startsWith("margin") ||
                prop.startsWith("padding") ||
                prop.startsWith("font-family") ||
                prop.startsWith("line-height") ||
                prop.startsWith("mso-");

            return !isNoisy;
        });

        const cleanedStyle = keptRules.join(";").trim();

        if (cleanedStyle) {
            el.setAttribute("style", cleanedStyle);
        } else {
            el.removeAttribute("style");
        }
    });

    // Tables: force full width + collapsed borders
    container.querySelectorAll("table").forEach((el) => {
        el.style.width = "100%";
        el.style.borderCollapse = "collapse";
    });

    // Images: responsive, centered
    container.querySelectorAll("img").forEach((el) => {
        el.style.maxWidth = "100%";
        el.style.height = "auto";
        el.style.display = "block";
        el.style.margin = "10px auto";
    });

    // Links: consistent color, open in new tab
    container.querySelectorAll("a").forEach((el) => {
        el.style.color = "#0d6efd";
        el.style.textDecoration = "none";
        el.setAttribute("target", "_blank");
    });

    // Remove empty paragraphs left behind after cleanup
    let cleaned = container.innerHTML
        .replace(/<p><br><\/p>/gi, "")
        .replace(/<p>\s*<\/p>/gi, "");

    return cleaned;
};

/* ---------------- COMPONENT ---------------- */

const EmailEditor = ({ emailContent, setEmailContent }) => {

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"]
        ],

        clipboard: {
            matchVisual: false
        }
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "color",
        "background",
        "align",
        "list",
        "bullet",
        "link",
        "image"
    ];

    const handleChange = (content) => {
        setEmailContent(content);
    };

    const handlePaste = (e) => {
        const html = e.clipboardData.getData("text/html");

        if (html) {
            e.preventDefault();

            const cleanHtml = cleanPastedHtml(html);

            setEmailContent((prev) => prev + cleanHtml);
        }
    };

    return (
        <div onPaste={handlePaste}>
            <ReactQuill
                theme="snow"
                value={emailContent}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                placeholder="Write or paste Gmail content here..."
                style={{
                    background: "white",
                    minHeight: "320px"
                }}
            />

            <style>
                {`
                .ql-editor{
                    min-height:280px;
                    font-family:Arial,sans-serif;
                    font-size:15px;
                    line-height:1.6;
                }

                .ql-editor img{
                    max-width:100%;
                    height:auto;
                }

                .ql-editor table{
                    width:100%;
                    border-collapse:collapse;
                }

                .ql-editor td,.ql-editor th{
                    border:1px solid #ddd;
                    padding:8px;
                }
                `}
            </style>
        </div>
    );
};

export default EmailEditor; 